import React from 'react';
import { compose } from 'redux';
import PageView from 'hoc/PageView';
import AuthTemplateContainer from 'containers/AuthTemplateContainer';

import SetPasswordForm from 'components/organisms/forms/CreatePassword';

const CreatePasswordPage = () => (
    <AuthTemplateContainer>
        <SetPasswordForm />
    </AuthTemplateContainer>
);

export default compose(
    PageView({ page: 'Viewed Set Password Screen' })
)(CreatePasswordPage);



// WEBPACK FOOTER //
// ./src/components/pages/CreatePassword.js